import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';

const OrderTabs = ({ activeTab, onTabChange }) => {
    return (
        <Box sx={{ width: "100%", marginTop: "20px" ,padding:"1rem" }} key="tabs-wrapper">
            <Tabs
                value={["limit", "executed"].indexOf(activeTab)}
                onChange={onTabChange}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="transparent"
                sx={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    display: "flex",
                    height: "25px",
                    marginBottom: "20px",
                }}
                key="tabs-component"
            >
                <Tab
                    key="limit"
                    label="Limits"
                    sx={{
                        borderRadius: "50px",
                        fontSize: "14px",
                        padding: "10px 0",
                        margin: "0 4px",
                        backgroundColor: "transparent",
                        color: "#000",
                        textTransform: "none",
                        width: "33.33%",
                        height: "15px",
                        "&.Mui-selected": {
                            backgroundColor: "#ccebff",
                            color: "#006bb3",
                            borderRadius: "50px",
                            boxShadow: "none",
                            fontWeight: "bold",
                        },
                    }}
                />
                <Tab
                    key="executed"
                    label="Executed"
                    sx={{
                        borderRadius: "50px",
                        fontSize: "14px",
                        padding: "10px 0",
                        margin: "0 4px",
                        backgroundColor: "transparent",
                        color: "#000",
                        textTransform: "none",
                        width: "33.33%",
                        height: "15px",
                        "&.Mui-selected": {
                            backgroundColor: "#ccebff",
                            color: "#006bb3",
                            borderRadius: "50px",
                            boxShadow: "none",
                            fontWeight: "bold",
                        },
                    }}
                />
            </Tabs>
        </Box>
    );
};

export default OrderTabs;